import axios from 'axios'

export default {
    state: {
        recipes: []
    },
    getters: {
        recipes: state => {
            return state.recipes
        }
    },
    mutations: {
        SET_RECIPES (state, recipes) {
            state.recipes = recipes
        }
    },
    actions: {
        GET_RECIPES (context, vm) {
            console.log('author:')
            console.log(vm.$store.getters.author)
            if (vm.$store.getters.author) {
                vm.withAuth(function () {
                    var headers = {}
                    headers['Authorization'] = 'Bearer ' + vm.$store.getters.id_token
                    axios.get('/api/author/recipes', { headers: headers })
                        .then(response => {
                            if (response.data) {
                                let recipes = response.data.recipes
                                context.commit('SET_RECIPES', recipes)
                            }
                        })
                })
            } else {
                axios.get('/api/recipes')
                .then(response => {
                    if (response.data) {
                        let recipes = response.data.recipes
                        context.commit('SET_RECIPES', recipes)
                    }
                })
            }
        }
    }
}